module.exports = __webpack_public_path__ + "fonts/Poppins-BoldItalic.19406f76.ttf";